import Vue from 'vue'

import 'styles/base.styl'
import 'global'
import 'icons'

import axios from 'axios'
import cookies from 'js-cookie'
axios.defaults.headers.common['X-CSRFToken'] = cookies.get('csrftoken')

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import Template from 'templates'
import router from 'core/router'
import store from 'core/store'
import { sync } from 'vuex-router-sync'
sync(store, router)

new Vue({
	async beforeCreate() {
		await store.dispatch('init')
	},
	el: '#app',
	router,
	store,
	render: h => h(Template)
})
